$(document).ready(function() {
  var winW = $(window).width();

  // Product
  $('#main-photo ul').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '#mini-photos ul'
  });

  $('#mini-photos ul').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: '#main-photo ul',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 830,
        settings: {
          vertical: false,
        }
      }
    ]
  });

  // Shop The Look
  $('.pro-shop #photo ul').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '#gallery ul'
  });

  $('.pro-shop #gallery ul').slick({
    focusOnSelect: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    vertical: true,
    asNavFor: '#photo ul',
    responsive: [
      {
        breakpoint: 830,
        settings: {
          vertical: false,
        }
      }
    ]
  });

  // Header
  var barraH = $('.barra').outerHeight();
  var headerH = $('header').outerHeight();

  padding_menu(barraH, headerH);

  $(window).resize(function() {
    barraH  = $('.barra').outerHeight();
    headerH = $('header').outerHeight();
    padding_menu(barraH, headerH);
  });

  function padding_menu(barra, header, menu = 0) {
    $('body').css('padding-top', barra + header);
    $('header').css('top', barra);
  }

  $(window).scroll(function() {
    if ($(window).scrollTop() > barraH) {
      $('header').addClass('fix');
      $('header').css('top', 0);
    } else {
      $('header').removeClass('fix');
      $('header').css('top', barraH);
    }
  });

  $('header .icons li .search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .big-search .cerrar-big-search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .icons li .cart').click(function() {
    $('#minicart').addClass('show');
  });

  $('#minicart .cerrar').click(function() {
    $('#minicart').removeClass('show');
  });

  $('header .show-menu').click(function() {
    $('nav').addClass('show');
  });

  $('header nav .cerrar').click(function() {
    $('nav').removeClass('show');
  });

  // Product
$('.product .deon > h3').each(function() {
  $(this).addClass('accor');
  $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>');
  
  // If the header is "Descripción", show its content by default
  if ($(this).text() === "Descripción") {
    $(this).addClass('active');
    $(this).next('.hide-info').addClass('show');
  }
});

  $('.product .deon h3').click(function() {
    $(this).toggleClass('active');
    $(this).next('.hide-info').toggleClass('show');
  });

  $('.featured-collection ul .item[data-id="4833619345540"]').remove();
  $('.featured-collection ul .item[data-id="4833617182852"]').remove();

  // Pop Up
  $('#popup .cerrar').click(function() {
    $('#popup').removeClass('show');
  });

  if ( winW < 830 ) {
    $('nav ul.menu > li.site-nav--has-dropdown > a').each(function() {
      var href = $(this).attr('href');
      $(this).click(function(e) {
        e.preventDefault();
      });
    });

    $('nav ul.menu > li.site-nav--has-dropdown').click(function() {
      $(this).siblings().children('.sub-menu').removeClass('show');
      $(this).children('.sub-menu').toggleClass('show');
    });
  }

  $('.item .addcart').click(function() {
    var proVar = $(this).data('product-id');
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: proVar
      },
      success: function(data) {
      },
      error: function(data) {
        if (data.status == 422) {
          $('.item-' + proVar + ' .alertas').text('Sin stock disponible');
        }
      },
      async: false
    });
    update_mini_cart(true);
  });
});

$('body').on('click', '#minicart .middle .left i.delete-prod', function(e) {
  var var_this = this;
  Shopify.removeItem($(this).data('id'), function() {
    $(var_this).parent().parent().fadeOut(200);
    update_mini_cart();
  });
});

/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function update_mini_cart(show = false) {
  $('#minicart .middle ul').empty();
  $("#minicart .cifra").empty();
  jQuery.get("/cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      var titulo     = data.items[i]["product_title"];
      var varianteID = data.items[i]["variant_id"];
      var precio     = data.items[i]["price"] ? parseFloat(data.items[i]["price"]).toString().substring(0, parseFloat(data.items[i]["price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      var cantidad   = data.items[i]["quantity"];
      var imagen     = data.items[i]["image"];
      var alt        = data.items[i]["featured_image"]["alt"];
      var proMini    = "<li><div class='left'><i class='far fa-trash-alt delete-prod' data-id='" + varianteID + "'></i><h4>" + titulo + "</h4><h5>$" + precio + "</h5><h6>Cantidad: <span>" + cantidad + "</span></h6></div><div class='right'><img src='" + imagen + "' alt='" + alt + "' loading='lazy' /></div></li>";
      $("#minicart .middle ul").append(proMini);
    }
    var total     = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var itemcount = data.item_count;
    $("#minicart .cifra").append('$' + total);
    $("header .icons li a.cart .count").html(itemcount);
    if (show) {
      $('#minicart').addClass('show');
    }
  }, 'json');
}